import { Model as BaseModel, FreedataValueVO } from '@wizeoo/akm-common-lib';
import { KeycloakService } from 'keycloak-angular';
import { AiResponse, AiQuestion } from '@wizeoo/akm-message-lib';

/**
 * conteneur de données METIER (données, PAS objets uniques d'IHM NI méthodes statiques)
 * singleton
 * Même s'il existe des managers, les données utilisées sur plusieurs vues DOIVENT se trouver ici
 * Les collections utilisées par plusieurs vues DOIVENT se trouver ici
 * Le manager de ces collections ne fait que des traitements. Ici est la vérité
 */
export class Model extends BaseModel {

  public origin: string = 'AKM';

  constructor() { 
    super();
  }

  /** accesseur sur l'instance */
  public static getInstance(): Model {
    if (!this._instance) {
      this._instance = new Model();
    }
    return this._instance as Model;
  }

  /** injecté depuis appInit, lien vers le service d'Oauth */
  public security: KeycloakService = null;

  /** injecté depuis appComponent, référence au webworker */
  public webworker: Worker = null;

  /** Prototype en cours */
  public currentPrototype: FreedataValueVO = null;

  /** vue en cours */
  public currentViewCode: string = null;


  public aiResponseCollection: AiResponse[] = null;

  /**
   * map des question par code interne
   */
  public questionMap: Map<string, AiQuestion> = null;

  /**
   * affichage des logs
   */
  public logs: string[] = [];

  /**
   * type de device en cours   * (injection depuis appInit après détection) et detecté sur la vue de menu
   */
  public isMobile: boolean = false;
  public isIphoneRounded: boolean = false;


}
